import { render, staticRenderFns } from "./product-list-pagination.vue?vue&type=template&id=41a6515a&scoped=true"
import script from "./product-list-pagination.vue?vue&type=script&lang=js"
export * from "./product-list-pagination.vue?vue&type=script&lang=js"
import style0 from "./product-list-pagination.vue?vue&type=style&index=0&id=41a6515a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a6515a",
  null
  
)

export default component.exports